import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { Cluster } from '../types/cluster';
import { EstablishmentClustersFilterProps } from '../types/clusterFilters';
import QueryString from "qs"
import usePrivateAxios from '@/common/api/usePrivateAxios';

export const useEstablishmentClusters = (filters: EstablishmentClustersFilterProps) => {
  const privateAxios = usePrivateAxios();
  const hasQueryParams = !!(
    filters.top_left_lat &&
    filters.top_left_lng &&
    filters.bottom_right_lat &&
    filters.bottom_right_lng
  );
  return useQuery({
    queryKey: ['establishmentClusters', filters],
    queryFn: async () => {
      const queryString = QueryString.stringify(filters);
      const { data } = await privateAxios.get<{ data: Cluster[] }>(
        `/establishment/companies/geo_clustered?${queryString}`, {
          params: {
            'q[product_category_id_eq]': filters.productCategoryId,
          }
        }
      );
      return data;
    },
    placeholderData: keepPreviousData,
    select: (returnedData) => returnedData?.data || [],
    enabled: hasQueryParams,
  });
};
